// extracted by mini-css-extract-plugin
export default {"productList":"productList_style_productList__uyIpL","noProducts":"productList_style_noProducts__xVjWO"};